import billing from "./billing.json";
import commons from "@translations/en";
import channels from "./channels.json";
import compare_plans from "./compare_plans.json";
import inputs from "./inputs.json";
import integrations from "./integrations.json";
import languages from "./languages.json";
import countries from "./countries.json";
import modals from "./modals.json";
import notifications from "./notifications.json";
import order from "./order.json";
import plans from "./plans.json";
import profile from "./profile.json";
import services from "./services.json";
import subscription from "./subscription.json";
import users from "./users.json";

export default {
    billing: billing,
    commons: commons,
    channels: channels,
    compare_plans: compare_plans,
    inputs: inputs,
    integrations: integrations,
    modals: modals,
    languages: languages,
    countries: countries,
    notifications: notifications,
    order: order,
    plans: plans,
    profile: profile,
    services: services,
    subscription: subscription,
    users: users
};